import { render, staticRenderFns } from "./XOLRecovery.vue?vue&type=template&id=14b1029b&"
import script from "./XOLRecovery.vue?vue&type=script&lang=js&"
export * from "./XOLRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports